import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faChevronDown, faChevronUp} from '@fortawesome/free-solid-svg-icons';
import './styles.css';
/**
 * Átomo <SortHeader />
 * Renderiza un encabezado con el texto y las flechas de ordenamiento.
 *
 * @component
 * @param {string} label - Texto del encabezado
 * @param {string} className - Clase CSS adicional
 */
const SortHeader = ({ label, className }) => {
  SortHeader.propTypes = {
    label: PropTypes.string.isRequired,
    className: PropTypes.string
  };
  return (
    <div className={`sort-header ${className || ''}`}>
      <span className="sort-label">{label}</span>

      <div className="sort-arrows">
        <button className="sort-arrow-up" aria-label="Sort Ascending">
          <FontAwesomeIcon className="arrow arrow-up" icon={faChevronUp} />
        </button>
        <button className="sort-arrow-down" aria-label="Sort Descending">
          <FontAwesomeIcon className="arrow arrow-down" icon={faChevronDown} />
        </button>
      </div>
    </div>  

    //  / faCaretDown 
  );
};



export default SortHeader;
